function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import classNames from 'classnames';
import { formatDistanceToNowStrict } from 'date-fns';
import { Form, useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Checkbox from '../../../components/form/Checkbox';
import Control from '../../../components/form/Control';
import { softwares } from '../../../components/mapView/constants';
import { MapViewContext } from '../../../components/mapView/mapViewContext';
import TextDivider from '../../../components/text/TextDivider';
import { DEFAULT_CURRENCY } from '../../../constants/price';
import { profileSelectors } from '../../../redux/selectors/profile';
import text, { formatCurrency } from '../../../text';
import { isJobPayable } from '../../../utilities/job';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff } from '../../../utilities/user';
import MembershipInvoice from '../Invoice/MembershipInvoice';
import ProductInvoice from '../Invoice/ProductInvoice';
var ConfirmationForm = function() {
    var jobId = useParams().jobId;
    var _useSelector = useSelector(function(state) {
        return {
            job: state.jobsReducer.job,
            membershipPriceId: state.order.membershipPriceId,
            membershipPrices: state.profileReducer.membershipPrices,
            currentUser: state.profileReducer.userProfile
        };
    }), job = _useSelector.job, membershipPriceId = _useSelector.membershipPriceId, membershipPrices = _useSelector.membershipPrices, currentUser = _useSelector.currentUser;
    var currency = job && job.quote ? _object_spread({}, job.quote.currency) : DEFAULT_CURRENCY;
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, handleChange = _useFormikContext.handleChange;
    var hasValidMembership = useSelector(profileSelectors.hasValidMembership);
    var _useContext = useContext(MapViewContext), buyNowData = _useContext.state.buyNowData;
    var selectedMembership = useMemo(function() {
        if (membershipPrices.value) {
            return membershipPrices.value.find(function(membership) {
                return membership.id === membershipPriceId;
            });
        }
        return null;
    }, [
        membershipPriceId,
        membershipPrices
    ]);
    var estimatedDelivery = useMemo(function() {
        if (!jobId) {
            // return TBC if no jobId immediately
            // this only means origin of the flow is not from Order since there's no jobId from params
            // e.g. probably from membership upgrade flow
            return null;
        }
        if (!job.quote.expected_at) {
            return text('toBeConfirmed');
        }
        return formatDistanceToNowStrict(new Date(job.quote.expected_at), {
            roundingMethod: 'round'
        });
    }, [
        job,
        jobId
    ]);
    var totalDataPrice = jobId // refer to comment above in `estimatedDelivery`
     ? isMembershipPriceId(membershipPriceId) ? job.quote.price.member_grand_total : job.quote.price.grand_total : 0;
    /**
   * NOTE:
   * !jobId = no jobId - so it only means the flow is not from order
   * adding some classNames to match styling from requirement
   * and not to change the Step in order flow since
   * it's re-using the component
   */ var hasPurchasedMembership = !isEmpty(selectedMembership);
    var canShowTotalDataPrice = useMemo(function() {
        return buyNowData.length > 0 && jobId;
    }, [
        buyNowData.length,
        jobId
    ]);
    var numOrder = useMemo(function() {
        return [
            canShowTotalDataPrice,
            hasPurchasedMembership
        ].filter(function(v) {
            return !!v;
        }).length || 1;
    }, [
        hasPurchasedMembership,
        canShowTotalDataPrice
    ]);
    return /*#__PURE__*/ React.createElement(Form, {
        className: "ConfirmationForm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "orderSummary"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: classNames({
            'mt-2 mb-5 text-center': !jobId
        })
    }, text('confirmOrder')), jobId ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "pr-3 font-weight-bold"
    }, text('projectName'), ":"), /*#__PURE__*/ React.createElement("p", null, job.project.name)), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "pr-3 font-weight-bold"
    }, text('yourSoftware'), ":"), /*#__PURE__*/ React.createElement("p", null, softwares.entities[job.customer_software].name)), job.message ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", null, text('comments'), ":"), /*#__PURE__*/ React.createElement(Control, {
        className: "Message",
        as: "textarea",
        rows: 3,
        value: job.message,
        readOnly: true
    })) : null) : null), /*#__PURE__*/ React.createElement("div", {
        className: "totalSummary"
    }, /*#__PURE__*/ React.createElement(TextDivider, {
        isComplete: true
    }), canShowTotalDataPrice ? /*#__PURE__*/ React.createElement(Row, {
        className: "Price"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement("div", {
        className: "PriceHeader",
        style: {
            fontWeight: 500
        }
    }, numOrder - (numOrder > 1), ".", ' ', text(isJobPayable(job) ? 'dataInDatabase' : 'dataPayLater'))), /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement("h4", {
        className: "text-right"
    }, totalDataPrice ? formatCurrency(totalDataPrice, currency.name, currency.scale_factor, {}, true) : text('toBeConfirmed')))) : null, hasPurchasedMembership ? /*#__PURE__*/ React.createElement(Row, {
        className: classNames('Price', {
            'pt-1': !jobId
        })
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            fontWeight: 500
        },
        className: "PriceHeader"
    }, numOrder, ". ", !jobId ? "".concat(text('invoice'), " - ") : null, ' ', text('membership'))), /*#__PURE__*/ React.createElement(Col, null, /*#__PURE__*/ React.createElement("h4", {
        className: "text-right"
    }, formatCurrency(selectedMembership.grand_total, currency.name, currency.scale_factor, {}, true)))) : null, estimatedDelivery ? /*#__PURE__*/ React.createElement(Row, {
        className: "Price mt-3"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement("div", {
        className: "PriceHeader"
    }, text('deliveryTime'), ":"), /*#__PURE__*/ React.createElement("h4", null, "~", estimatedDelivery)), /*#__PURE__*/ React.createElement(Col, {
        xs: 12,
        md: 6
    })) : null), /*#__PURE__*/ React.createElement("hr", null), jobId ? /*#__PURE__*/ React.createElement("div", {
        className: "invoiceSummary"
    }, !hasValidMembership && !isStaff(currentUser.role) && /*#__PURE__*/ React.createElement(MembershipInvoice, {
        jobId: jobId
    }), /*#__PURE__*/ React.createElement(ProductInvoice, {
        jobId: jobId
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: classNames('Terms', {
            'mt-4 mb-4 d-flex flex-row justify-content-center': !jobId
        })
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        onChange: handleChange,
        name: "terms",
        id: "terms",
        value: values.terms,
        labelClass: "ml-3"
    }, text('acceptTermsAndConditions', {
        termsConditions: /*#__PURE__*/ React.createElement(Link, {
            key: "urlTerms",
            to: {
                pathname: process.env.LARKI_URL_TERMS
            },
            target: "_blank"
        }, text('termsAndConditions'))
    }))));
};
export default ConfirmationForm;
